export default __webpack_public_path__ + "static/media/img-gnb-women-on.1d9a8988.svg";